/* AA CRO layer JS — per-day pricing, sub nudge, evergreen countdown, sticky proof */
(function () {
  var PACKS_PER_UNIT = 28;

  function parsePrice(el) {
    if (!el) return null;
    var m = (el.textContent || '').replace(/,/g, '').match(/([0-9]+(?:\.[0-9]+)?)/);
    return m ? parseFloat(m[1]) : null;
  }

  function decoratePerDay() {
    document.querySelectorAll('.loop-widget-purchase-option').forEach(function (opt) {
      if (opt.querySelector('.aa-per-day')) return;
      var priceEl = opt.querySelector('.loop-widget-purchase-option-price') ||
                    opt.querySelector('.loop-widget-purchase-option-price-container');
      var price = parsePrice(priceEl);
      if (!price) return;
      var perDay = price / PACKS_PER_UNIT;
      var chip = document.createElement('span');
      chip.className = 'aa-per-day';
      chip.textContent = 'just $' + perDay.toFixed(2) + '/day';
      var host = opt.querySelector('.loop-widget-purchase-option-price-container') || priceEl;
      if (host && host.parentNode) host.parentNode.appendChild(chip);
    });
  }

  function ensureNudge() {
    var container = document.querySelector('.loop-widget-purchase-options-container');
    if (!container) return;
    var opts = container.querySelectorAll('.loop-widget-purchase-option');
    if (opts.length < 2) return;
    var oneTime = null;
    opts.forEach(function (o) {
      if (/one.?time/i.test(o.textContent)) oneTime = o;
    });
    if (!oneTime) return;
    var nudge = oneTime.querySelector('.aa-sub-nudge');
    if (!nudge) {
      nudge = document.createElement('div');
      nudge.className = 'aa-sub-nudge';
      nudge.textContent = 'Get more savings + free shipping with a subscription →';
      oneTime.appendChild(nudge);
    }
    var selected = oneTime.classList.contains('loop-widget-purchase-option-selected');
    nudge.classList.toggle('aa-sub-nudge--visible', selected);
  }

  function startCountdown() {
    var els = document.querySelectorAll('[data-aa-countdown]');
    if (!els.length) return;
    var FIVE_H = 18000000;
    var KEY = 'aa_offer_end';
    function deadline() {
      var end = parseInt(localStorage.getItem(KEY) || '0', 10);
      if (!end || end - Date.now() > FIVE_H || end < Date.now()) {
        end = Date.now() + FIVE_H;
        try { localStorage.setItem(KEY, String(end)); } catch (e) {}
      }
      return end;
    }
    function tick() {
      var now = Date.now();
      var end = deadline();
      var left = Math.max(0, end - now);
      var h = Math.floor(left / 3600000);
      var m = Math.floor((left % 3600000) / 60000);
      var s = Math.floor((left % 60000) / 1000);
      var t = (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      els.forEach(function (e) { e.textContent = t; });
    }
    tick();
    setInterval(tick, 1000);
  }

  function stickyProof() {
    var bar = document.querySelector('.sticky-atc-bar');
    if (!bar || bar.querySelector('.aa-sticky-proof')) return;
    var proof = document.createElement('div');
    proof.className = 'aa-sticky-proof';
    proof.innerHTML = '<span class="aa-sp-stars">⭐ 4.9 · Thousands of families</span><span class="aa-sticky-badge">SUBSCRIBE &amp; SAVE 20%</span>';
    var form = bar.querySelector('.sticky-atc-bar__form') || bar;
    form.insertBefore(proof, form.firstChild);
    var gate = document.querySelector('[id*="you-not-lazy"]');
    if (gate) {
      var update = function () {
        var show = gate.getBoundingClientRect().top < window.innerHeight * 0.85;
        bar.classList.toggle('aa-gate-show', show);
      };
      update();
      window.addEventListener('scroll', update, { passive: true });
      document.addEventListener('scroll', update, { passive: true, capture: true });
      setInterval(update, 400);
    } else {
      bar.classList.add('aa-gate-show');
    }
  }
  function mobileATF() {
    if (window.innerWidth > 749) return;
    var product = document.querySelector('.product.flex');
    var info = document.querySelector('.product__info-wrapper');
    if (!product || !info || document.querySelector('.aa-mobile-atf')) return;
    var blocks = [].slice.call(info.querySelectorAll('.product__block'));
    var stars = null, head = null;
    blocks.forEach(function (b) {
      if (!stars && b.querySelector('#aa_page_anchor')) stars = b;
      if (!head && /EVERYTHING GROWING/i.test(b.textContent)) head = b;
    });
    if (!stars || !head) return;
    var atf = document.createElement('div');
    atf.className = 'aa-mobile-atf';
    atf.appendChild(stars);
    atf.appendChild(head);
    product.insertBefore(atf, product.firstChild);
  }

  
  function cardBanner() {
    document.querySelectorAll('.loop-widget-purchase-option').forEach(function (o) {
      if (/one.?time/i.test(o.textContent)) return;
      if (o.querySelector('.aa-card-banner')) return;
      var b = document.createElement('div');
      b.className = 'aa-card-banner';
      b.textContent = 'Most Popular: Subscribe & Save 20%';
      o.insertBefore(b, o.firstChild);
    });
  }
  function thumbsRail() {
    var gallery = document.querySelector('.product__media-gallery');
    if (!gallery || gallery.classList.contains('aa-gallery-rail')) return;
    var rail = null;
    document.querySelectorAll('[class*="thumb"]').forEach(function (e) {
      if (rail) return;
      var imgs = e.querySelectorAll('img');
      var r = e.getBoundingClientRect();
      if (imgs.length >= 2 && r.height > 0 && r.height < 260) rail = e;
    });
    if (!rail) return;
    var host = rail.closest('.product__media-gallery') === gallery ? rail : rail;
    gallery.classList.add('aa-gallery-rail');
    var railTop = host.closest('.product__media-gallery > *') || host;
    railTop.classList.add('aa-thumbs-rail');
  }

  
  function clinBanner() {
    var viewer = document.querySelector('.product__media-gallery-viewer');
    var badge = document.getElementById('frontrow-badge');
    if (!badge) { var f = document.querySelector('.iframe-frontrow, [id*="frontrow"]'); badge = f ? (f.closest('#frontrow-badge') || f) : null; }
    if (!viewer || !badge || badge.dataset.aaMoved) return;
    badge.dataset.aaMoved = '1';
    badge.classList.add('aa-frontrow-top');
    viewer.parentNode.insertBefore(badge, viewer.nextSibling);
  }

  /* sticky bar mirrors the selected Loop option price (sub w/ 20% by default) */
  function stickyPriceSync() {
    var bar = document.querySelector('.sticky-atc-bar');
    if (!bar) return;
    var sel = document.querySelector('.loop-widget-purchase-option-selected');
    if (!sel) return;
    var priceEl = sel.querySelector('.loop-widget-purchase-option-price') || sel.querySelector('.loop-widget-purchase-option-price-container');
    var cmp = sel.querySelector('.loop-widget-purchase-option-compare-at-price');
    var p = priceEl && priceEl.textContent.trim();
    if (!p) return;
    var box = bar.querySelector('.f-price');
    if (!box) return;
    var mine = bar.querySelector('.aa-sticky-price');
    if (!mine) {
      mine = document.createElement('div');
      mine.className = 'aa-sticky-price';
      box.style.display = 'none';
      box.parentNode.insertBefore(mine, box);
    }
    var was = cmp ? cmp.textContent.trim() : '';
    mine.innerHTML = p + (was && was !== p ? '<span class="aa-was">' + was + '</span>' : '');
  }

  /* Sticky bar: retain the concise CTA label without adding promotional copy. */
  function stickyExtras() {
    var bar = document.querySelector('.sticky-atc-bar');
    if (!bar) return;
    var btn = bar.querySelector('button[name="add"], .product-form__submit');
    if (btn) {
      var sp = btn.querySelector('span');
      if (sp && /subscription/i.test(sp.textContent)) sp.textContent = 'Get yours now';
    }
  }

  /* Keep purchase language consistent when Shopify or an app injects a CTA after page load. */
  function normalisePurchaseLabels(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var controls = [];
    if (root && root.nodeType === 1 && root.matches && root.matches('button, [role="button"], input[type="submit"]')) controls.push(root);
    controls = controls.concat(Array.prototype.slice.call(scope.querySelectorAll('button, [role="button"], input[type="submit"]')));
    controls.forEach(function (control) {
      if (control.tagName === 'INPUT') {
        if (/^\s*add\s+to\s+cart\s*$/i.test(control.value || '')) control.value = 'Get yours now';
        return;
      }
      var walker = document.createTreeWalker(control, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (/^\s*add\s+to\s+cart\s*$/i.test(node.nodeValue || '')) node.nodeValue = 'Get yours now';
      }
    });
  }

  /* Judge.me injects its widget CSS late with !important — body-appended style wins the cascade */
  function jdgmArrowFix() {
    if (document.getElementById('aa-jdgm-fix') || !document.body) return;
    var st = document.createElement('style');
    st.id = 'aa-jdgm-fix';
    st.textContent = '.jdgm-rev-snippet-widget-v2__arrow{width:44px !important;height:44px !important;padding:0 !important;border-radius:50% !important;background:#fff !important;border:1.5px solid #1A1A1A !important;display:flex !important;align-items:center !important;justify-content:center !important;box-shadow:0 2px 8px rgba(0,0,0,.12) !important;top:50% !important;transform:translateY(-50%) !important;opacity:1 !important;}' +
      '.jdgm-rev-snippet-widget-v2__arrow svg{width:9px !important;height:14px !important;display:block !important;flex:0 0 auto !important;}' +
      '.jdgm-rev-snippet-widget-v2__arrow:hover{background:#FFF3E8 !important;}' +
      '@media (min-width:990px){.jdgm-rev-snippet-widget-v2__inner{max-width:880px !important;margin-left:auto !important;margin-right:auto !important;overflow:visible !important;}.jdgm-rev-snippet-widget-v2__arrow--prev{left:-60px !important;}.jdgm-rev-snippet-widget-v2__arrow--next{right:-60px !important;}}';
    document.body.appendChild(st);
  }

  function boot() {
    jdgmArrowFix();
    decoratePerDay();
    ensureNudge();
    startCountdown();
    stickyProof();
    cardBanner();
    mobileATF();
    clinBanner();
    /* The retry only makes sense if the gallery viewer clinBanner() re-parents the badge
       next to actually exists. On the CUBE PDPs `main-product` is disabled, so
       .product__media-gallery-viewer is never rendered and clinBanner() early-returns
       every time — the old unconditional retry burned 20 ticks over 10s for nothing. */
    if (document.querySelector('.product__media-gallery-viewer')) {
      var _cbTries = 0, _cbInt = setInterval(function () { clinBanner(); if (++_cbTries > 20 || document.querySelector('#frontrow-badge.aa-frontrow-top')) clearInterval(_cbInt); }, 500);
    }
    stickyPriceSync();
    stickyExtras();
    normalisePurchaseLabels(document);
    /* Old clear condition required BOTH .aa-sticky-price and .aa-sticky-save. Nothing in
       this file (or any other) ever creates .aa-sticky-save — it is styled in aa-cro.css
       but never built — so the condition could never be true and the interval always ran
       the full 15 ticks. stickyPriceSync() also needs a Loop widget, which the CUBE PDPs
       do not render. Stop as soon as there is nothing left to do. */
    var _spTries = 0, _spInt = setInterval(function () {
      stickyPriceSync();
      stickyExtras();
      var hasLoopWidget = !!document.querySelector('.loop-widget-purchase-option-selected');
      var priceDone = !!document.querySelector('.aa-sticky-price');
      if (++_spTries > 15 || priceDone || !hasLoopWidget) clearInterval(_spInt);
    }, 700);
    var target = document.querySelector('.loop-widget-container');
    if (target && window.MutationObserver) {
      new MutationObserver(function () { decoratePerDay(); ensureNudge(); cardBanner(); stickyPriceSync(); })
        .observe(target, { subtree: true, attributes: true, attributeFilter: ['class'], childList: true });
    }
    /* Scoped, not document.body.
       This observer exists to relabel "Add to cart" CTAs that Shopify or an app injects
       after load. Previously it watched document.body with subtree + childList +
       characterData, so it fired on every node Judge.me, Klaviyo, Gorgias and Clarity
       inject — each callback then walking the injected subtree with a TreeWalker. That is
       a steady INP/TBT tax for a job that only ever concerns three containers.
       Watch those containers instead, and only fall back to body if none are present. */
    if (window.MutationObserver) {
      var roots = [];
      ['.aap-buy', '.sticky-atc-bar', 'cart-drawer', '.cart-drawer'].forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          if (roots.indexOf(el) === -1) roots.push(el);
        });
      });
      if (!roots.length && document.body) roots.push(document.body);
      var relabel = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'characterData') normalisePurchaseLabels(mutation.target.parentNode);
          Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
            if (node.nodeType === 1) normalisePurchaseLabels(node);
          });
        });
      });
      roots.forEach(function (root) {
        relabel.observe(root, { subtree: true, childList: true, characterData: true });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(boot, 800); });
  } else {
    setTimeout(boot, 800);
  }
})();
